<template>
    <div class="layout overflow-hidden">
        <aside class="sidebar bg-light">
            <div class="tab-content h-100" role="tablist">
                <!-- Chats -->
                <div class="tab-pane fade h-100 show active" id="tab-content-chats" role="tabpanel" style="background: #f6f9fb;">
                    <div class="d-flex flex-column h-100 position-relative">
                        <div class="hide-scrollbar">

                            <div class="container py-8">
                                <!-- Title -->
                                <div class="mb-8">
                                    <h2 class="fw-bold m-0">Chats</h2>
                                </div>

                                <!-- Search -->
                                <div class="mb-6">
                                    <form action="#">
                                        <div class="input-group">
                                            <input type="text" class="form-control form-control-lg p" placeholder="Search messages or users" aria-label="Search for messages or users...">
                                        </div>
                                    </form>
                                </div>

                                <!-- Chats -->
                                <div class="card-list">
                                    <div 
                                        class="card border-0 text-reset cursor-pointer"
                                        :class="currentConversationId == conversation.id ? 'active' : ''"
                                        v-for="conversation in conversations" :key="conversation.id"
                                        @click="selectConversation(conversation)"
                                    >
                                        <div class="card-body">
                                            <div class="row gx-5">
                                                <div class="col-auto">
                                                    <div class="avatar avatar-onlin">
                                                        <img :src="isDashboardCompany 
                                                            ? conversation.sender.avatar ? baseUrl + conversation.sender.avatar : '../../assets/img/user.png'
                                                            : conversation.company.logo ? baseUrl + conversation.company.logo : '../../assets/img/user.png'
                                                            "
                                                            alt="#avatar-img-user"
                                                            class="avatar-img"
                                                            @error="handleImageError"
                                                        >
                                                    </div>
                                                </div>

                                                <div class="col">
                                                    <div class="d-flex justify-content-start align-items-start">
                                                        <h5 class="me-auto mb-0">{{ isDashboardCompany ? `${conversation.sender.first_name} ${conversation.sender.last_name}` : conversation.company.company_name }}</h5>
                                                        <span class="text-muted small ms-2">{{ conversation.updated_at || conversation.created_at | timeAgo }}</span>
                                                    </div>

                                                    <div class="text-start">
                                                        <div class="line-clamp me-auto">
                                                            {{ conversation.conversation }}
                                                        </div>
                                                        <span class="position-absolute badge rounded-circle bg-info text-white" style="top: 40px; right: 2px; background: #17a2b8 !important; color: white !important;" v-if="conversation.unread_messages > 0">
                                                            <span>{{ conversation.unread_messages }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Card -->
                                </div>
                                <!-- Chats -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </aside>
        <!-- Sidebar -->

        <!-- Chat -->
        <main class="main is-visible" data-dropzone-area="">
            <div class="container h-100">

                <div class="d-flex flex-column h-100 position-relative">
                    <!-- Chat: Header -->
                    <div class="d-flex justify-content-between align-items-center chat-header py-5 border-bottom">
                        <div class="d-flex justify-content-start align-items-center">
                            <!-- Content -->
                            <h2 class="text-truncate text-start m-0">{{ currentConversationName }}</h2>
                            <!-- Content -->
                        </div>
                        <div class="close-icon cursor-pointer" @click="closeChat">X</div>
                    </div>
                    <!-- Chat: Header -->

                    <!-- Chat: Content -->
                    <div class="chat-body hide-scrollbar flex-1 h-100" v-if="currentConversationId">
                        <div class="chat-body-inner">
                            <div class="py-6 py-lg-12">
                                <div v-for="(message, index) in messages" :key="message.id" class="message" :class="message.message_from != currentUserId ? 'message-out' : ''">
                                    <div class="message-inner">
                                        <div class="message-body">
                                            <div class="message-content d-flex flex-col">
                                                <div class="message-text text-start">
                                                    <p>{{ message.message }}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Display name and date if sender changes or for the last message in a sequence -->
                                        <div class="message-footer" v-if="shouldDisplayFooter(index)">
                                            <span class="extra-small text-muted" v-if="isDashboardCompany">
                                                {{ message.message_from != currentUserId ? currentUser.sender.first_name : currentUser.receiver.first_name }},
                                                {{ formatDateCustomized(message.created_at) }}
                                            </span>
                                            <span class="extra-small text-muted" v-else>
                                                {{ message.message_from == currentUserId ? currentUser.sender.first_name : currentUser.receiver.first_name }},
                                                {{ formatDateCustomized(message.created_at) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br /><br />
                    </div>
                    <!-- Chat: Content -->

                    <main class="main" v-else>
                        <div class="container h-100">

                            <div class="d-flex flex-column h-100 justify-content-center text-center">
                                <div class="mb-6">
                                    <span class="icon-xl text-muted">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-message-square"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                                    </span>
                                </div>

                                <p class="text-muted">Pick a person from left menu, <br> and start your conversation.</p>
                            </div>
                        </div>
                    </main>

                    <!-- Chat: Footer -->
                    <div class="chat-footer pb-3 pb-lg-7 bottom-0 start-0" v-if="currentConversationId">

                        <!-- Chat: Form -->
                        <form class="chat-form rounded-pill bg-dark w-100" style="position: relative;">
                            <div class="row align-items-center gx-0 w-100" style="position: relative;">
                                <div class="col">
                                    <div class="">
                                        <textarea
                                            class="form-control px-4"
                                            placeholder="Type your message..."
                                            rows="1"
                                            col="12"
                                            data-emoji-input=""
                                            data-autosize="true"
                                            :class="isMessage ? '' : 'is-invalid'"
                                            v-model="message"
                                            @input="sendMessage"
                                        ></textarea>
                                    </div>
                                </div>

                                <div class="col-auto" @click.prevent="saveConversation">
                                    <button class="btn btn-icon btn-primary rounded-circle ms-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-send"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
                                    </button>
                                </div>
                            </div>
                        </form>
                        <!-- Chat: Form -->
                    </div>
                    <!-- Chat: Footer -->
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import { myMixins } from "@/mixins/mixins";
    export default {
        mixins: [myMixins],
        props: {
            isConversation: Boolean,
            currentConversationId: Number,
            receiverId: Number,
            isDashboardCompany: Boolean,
            conversations: Array,
            currentUser: Object,
            currentUserId: String,
            currentConversationName: String,
            messages: Array,
            isMessage: Boolean,
            closeChat: Function,
            baseUrl: String,
            selectConversation: Function,
            saveConversation: Function,
            formatDateCustomized: Function,
        },
        data() {
            return {
                message: null,
                // isMessage: true,
            };
        },
        watch: {
            message() {
                this.isMessage = true;
            }
        },
        methods: {
            sendMessage() {
                this.$emit('updateMessage', this.message);
            },
            resetMessage() {
                // Clear the message
                this.message = '';
                this.$emit('updateMessage', this.message);
            },
            shouldDisplayFooter(index) {
                // Check if this is the last message
                if (index === this.messages.length - 1) {
                    return true;
                }
                
                // Check if the next message is from a different sender
                const currentMessage = this.messages[index];
                const nextMessage = this.messages[index + 1];

                return currentMessage.message_from !== nextMessage.message_from;
            }
        }
    }
</script>
<style lang="css" scoped src="../../assets/styles/chat.css"></style>
<style scoped>
    .card-body:hover {
        background: #ebf1f7;
    }
</style>